<script setup>
useHead({});
</script>

<template>
  <NuxtLoadingIndicator />
  <TheSnackbar />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
